import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "crud-container" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = {
  key: 0,
  class: "crud-table"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "dialog"
}
const _hoisted_10 = { class: "dialog-content" }
const _hoisted_11 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateDialog && _ctx.openCreateDialog(...args))),
        class: "create-btn"
      }, "Create Customer")
    ]),
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "User Id"),
              _createElementVNode("th", null, "First Name"),
              _createElementVNode("th", null, "Last Name"),
              _createElementVNode("th", null, "Mail"),
              _createElementVNode("th", null, "Invoice Address"),
              _createElementVNode("th", null, "Invoice Mail"),
              _createElementVNode("th", null, "Invoice Mobile"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item._id
              }, [
                _createElementVNode("td", null, _toDisplayString(item._id), 1),
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, _toDisplayString(item.lastName), 1),
                _createElementVNode("td", null, _toDisplayString(item.mail), 1),
                _createElementVNode("td", null, _toDisplayString(item.invoiceAddress), 1),
                _createElementVNode("td", null, _toDisplayString(item.invoiceMail), 1),
                _createElementVNode("td", null, _toDisplayString(item.invoiceMobile), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.openEditDialog(item)),
                    class: "edit-btn"
                  }, "Edit", 8, _hoisted_4),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteItem(item._id)),
                    class: "delete-btn"
                  }, "Delete", 8, _hoisted_5)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        disabled: _ctx.page === 1,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.page - 1)))
      }, "Previous", 8, _hoisted_7),
      _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.totalPages), 1),
      _createElementVNode("button", {
        disabled: _ctx.page === _ctx.totalPages,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.page + 1)))
      }, "Next", 8, _hoisted_8)
    ]),
    (_ctx.dialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.isEdit ? 'Edit Item' : 'Create Item'), 1),
            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createTextVNode(" First Name ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemForm.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[17] || (_cache[17] = _createTextVNode(" Last Name ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemForm.lastName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.lastName]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[18] || (_cache[18] = _createTextVNode(" Mail ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.itemForm.mail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.mail]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[19] || (_cache[19] = _createTextVNode(" Password ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemForm.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.password]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[20] || (_cache[20] = _createTextVNode(" Invoice Address 1 ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemForm.invoiceAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceAddress]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[21] || (_cache[21] = _createTextVNode(" Invoice Address 2 ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.itemForm.invoiceAddress1) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceAddress1]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[22] || (_cache[22] = _createTextVNode(" Invoice Mail ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.itemForm.invoiceMail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceMail]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[23] || (_cache[23] = _createTextVNode(" Invoice Mobile ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.itemForm.invoiceMobile) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceMobile]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[24] || (_cache[24] = _createTextVNode(" PAN Number ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.itemForm.panNumber) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.panNumber]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[25] || (_cache[25] = _createTextVNode(" GST Number ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.itemForm.gstNumber) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.gstNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialog = false)),
                class: "cancel-btn"
              }, "Cancel"),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveItem && _ctx.saveItem(...args))),
                class: "save-btn"
              }, _toDisplayString(_ctx.isEdit ? 'Save' : 'Create'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}